import { useNavigate } from 'react-router-dom';
import '../CoursesPage/CoursesPage.css';
import './CursosBouticPage.css';

export const CURSO_FUNDAMENTOS_SLUG = 'fundamentos-ortodoncia-hibrida-alineadores';

const CursosBouticPage = () => {
  const navigate = useNavigate();

  const scrollToCatalog = () => {
    const el = document.getElementById('boutic-catalog');
    el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="courses-page">
      <section className="courses-hero">
        <div className="courses-hero-content">
          <div className="courses-hero-text">
            <div className="courses-hero-badges">
              <span className="courses-hero-badge courses-hero-badge-primary">
                <i className="fas fa-building" aria-hidden="true" />
                Formación IN-OFFICE
              </span>
              <span className="courses-hero-badge courses-hero-badge-primary">
                <i className="fas fa-user-md" aria-hidden="true" />
                Always Aligners
              </span>
            </div>
            <h1 className="courses-hero-title">
              Cursos <span className="courses-hero-title-accent">Boutic</span>
            </h1>
            <p className="courses-hero-description">
              Programas presenciales intensivos donde combinamos{' '}
              <strong>diagnóstico digital</strong>, planificación con software Nemotec y práctica clínica
              guiada por especialistas, con criterios biomecánicos y neuromusculares propios de la ortodoncia
              híbrida.
            </p>

            <div className="courses-hero-features">
              <div className="courses-hero-feature">
                <i className="fas fa-check-circle" aria-hidden="true" />
                <span>Aula y clínica enfoque híbrido</span>
              </div>
              <div className="courses-hero-feature">
                <i className="fas fa-check-circle" aria-hidden="true" />
                <span>Nemoceph · Nemocast · Nemofab</span>
              </div>
              <div className="courses-hero-feature">
                <i className="fas fa-check-circle" aria-hidden="true" />
                <span>Jornadas con pacientes</span>
              </div>
            </div>

            <button type="button" className="courses-hero-button" onClick={scrollToCatalog}>
              <i className="fas fa-layer-group" aria-hidden="true" />
              Ver programas
            </button>
          </div>
        </div>
      </section>

      <section className="courses-grid-section" id="boutic-catalog">
        <div className="courses-grid-container">
          <h2 className="courses-section-title">Programas disponibles</h2>
          <div className="courses-grid">
            <article className="course-card">
              <div className="course-card-image">
                <div className="course-card-image-placeholder">
                  <i className="fas fa-chalkboard-teacher" aria-hidden="true" />
                </div>
              </div>
              <div className="course-card-content">
                <div className="boutic-card-tags">
                  <span className="boutic-tag">Posgrado</span>
                  <span className="boutic-tag">16 h</span>
                  <span className="boutic-tag">2 días</span>
                </div>
                <h3 className="course-card-title">
                  FUNDAMENTOS DE ORTODONCIA HÍBRIDA CON ALINEADORES
                </h3>
                <p className="course-card-description">
                  Diagnóstico digital, planificación y clínica: integración de alineadores, aparatología fija y
                  anclaje esqueletal con flujo Nemotec y estrategias de staging.
                </p>
                <ul className="boutic-card-highlights">
                  <li>Día 1: teórico–práctico con software</li>
                  <li>Día 2: clínica con pacientes</li>
                  <li>Staging lineal, secuencial, diferencial, biomecánico y acelerado</li>
                </ul>
                <div className="course-card-actions">
                  <button
                    type="button"
                    className="course-card-btn course-card-btn-cart"
                    onClick={() => navigate(`/cursos-boutic/${CURSO_FUNDAMENTOS_SLUG}`)}
                  >
                    Ver programa completo
                    <i className="fas fa-arrow-right" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CursosBouticPage;
